<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <v-col cols="12">
        <tarjeta-datos
          :datos="[
            {
              nombre: 'CUPS',
              valor: [datos.CodigoCUPS, datos.NombreCalle]
                .filter((item) => item != null)
                .join(' - '),
            },
            { nombre: 'Codigo CUPS', valor: datos.CodigoCUPS },
          ]"
        >
        </tarjeta-datos>
      </v-col>
      
      <v-col cols="12" class="col-lg-4 col-sm-6">
        <tarjeta-datos
          header
          titulo="Dirección"
          icon="lightbulb"
          :datos="[
            { nombre: 'Provincia', valor: datos.TextoProvincia },
            { nombre: 'Ciudad', valor: datos.TextoCiudad },
            { nombre: 'Calle', valor: datos.NombreCalle },
            { nombre: 'Número', valor: datos.Numero },
            { nombre: 'Portal', valor: datos.TextoPortal },
            { nombre: 'Aclarador', valor: datos.Aclarador },
            { nombre: 'Distribuidora', valor: datos.Distribuidora },
          ]"
        >
        </tarjeta-datos>
        <tarjeta-datos
          class="mt-2"
          header
          titulo="Varios"
          icon="chevron-double-down"
          :datos="[
            { nombre: 'Ref Catastral', valor: datos.RefCatastral },
            { nombre: 'CNAE', valor: datos.TextoCnae },
            { nombre: 'Observaciones', valor: datos.Observaciones },
          ]"
        >
        </tarjeta-datos>
      </v-col>
      <v-col cols="12" class="col-lg-8 col-sm-6">
        <tarjeta-datos header titulo="Boletín" icon="note">
          <v-row no-gutters>
            <v-col class="pa-0 col-md-6" cols="12">
              <tarjeta-datos borderless
                :datos="[
                  { nombre: 'Nº Boletín', valor: datos.NumBoletin },
                  { nombre: 'Titulación', valor: datos.Titulacion },
                  { nombre: 'Colegio', valor: datos.Colegio },
                  {
                    nombre: 'Titular Certificado',
                    valor: datos.TitularCertificado,
                  },
                  { nombre: 'Director Obra', valor: datos.DirectorObra },
                  { nombre: 'Org. Control', valor: datos.Organismo },
                  { nombre: 'Nº CCI', valor: datos.CCI },
                  { nombre: 'Modalidad', valor: datos.Modalidad },
                  {
                    nombre: 'Observaciones Servicios Territoriales',
                    valor: datos.ObsTerritorial,
                  },
                ]"
              >
              </tarjeta-datos>
            </v-col>
            <v-col class="pa-0 col-md-6" cols="12">
              <tarjeta-datos borderless
                :datos="[
                  { nombre: 'Potencia Max Boletin', valor: datos.PotMax },
                  { nombre: 'Instalación', valor: datos.FechaIns },
                  { nombre: 'Vigencia', valor: datos.FechaVigencia },
                  { nombre: 'Fecha Favorable', valor: datos.FechaOk },
                  { nombre: null, valor: '' },
                  { nombre: 'Nº Colegio', valor: datos.NumColegiado },
                  { nombre: 'Nº Notificación', valor: datos.Notificacion },
                  { nombre: 'Categoría', valor: datos.Categoria },
                  {
                    nombre: 'Observaciones Instalación',
                    valor: datos.ObsInstalacion,
                  },
                ]"
              >
              </tarjeta-datos>
            </v-col>
          </v-row>
        </tarjeta-datos>
      </v-col>
      </v-row>

      
    <v-row v-else>
      <v-overlay absolute>
        <v-progress-circular
          size="50"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import { processToken } from "@/utils/index.js";

export default {
  components: {
    TarjetaDatos: () => import("@/components/TarjetaDatos.vue"),
  },
  data() {
    return {
      datos: null,
      loading: true,
    };
  },
  mounted() {
    let str = this.$store.getters.getDatosEmpresa;

    const { IdUsuario, IdAgente } = str.iss;
    const IdEmpresa = this.$store.getters.getIdEmpresa

    axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URL}/CUPS/GetCodigoCUPS/Empresa/${IdEmpresa}/Usuario/${IdUsuario}/CodigoCUPS/${this.$route.query.cups}`,
    }).then((res) => {
      this.datos = processToken(res.data).iss;
      this.loading = false;
    });
  },
};
</script>

<style>
</style>